<template>
  <div class="customInfo">
    <div class="top">
      <van-icon name="contact" class="icon" size="20px" />
      <div class="title">票据信息</div>
    </div>
    <div class="line"></div>
    <div class="bottom">
      <img
        v-for="(item, index) in imgList"
        :key="index"
        :src="item.imgUrlView"
        @click="preImg(imgList, index)"
      />
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    preImg(images, index) {
      ImagePreview({
        images: images.map((item) => item.imgUrlView),
        loop: false, //是否开启循环播放
        startPosition: index, //图片预览起始位置索引
      });
    },
  },
};
</script>

<style lang="less" scoped>
.customInfo {
  box-sizing: border-box;
  padding: 32px;
  width: 100%;
  min-height: 258px;
  background: #fff;
  border-radius: 24px;
  .top {
    height: 48px;
    display: flex;
    align-items: center;
    .icon {
      float: left;
    }
    .title {
      height: 48px;
      line-height: 48px;
      float: left;
      color: rgba(51, 51, 51, 1);
      font-size: 32px;
      font-weight: bold;
      margin-left: 8px;
    }
  }
  .bottom {
    width: 100%;
    min-height: 98px;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    img {
      width: 180px;
      height: 180px;
      background-size: 100%;
      border-radius: 16px;
    }
    img:nth-child(2n-1) {
      margin-left: 8px;
    }
    .column {
      display: flex;
      justify-content: space-between;
      .label {
        color: rgba(153, 153, 153, 1);
        font-size: 26px;
      }
      .value {
        color: rgba(51, 51, 51, 1);
        font-size: 26px;
      }
    }
  }
}
.line {
  margin: 24px 0;
  width: 100%;
  background: rgba(226, 228, 234, 1);
  height: 2px;
}
</style>
